import React, { KeyboardEvent, useRef } from 'react';
import FocusLock from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';

import useEventListener from '@use-it/event-listener';
import classNames from 'classnames';

import { isEscapeKey } from '../../utils/keyboard';

import styles from './Modal.scss';

interface ModalDialogProps {
  background?: boolean;
  focusLock?: boolean;
  scrollIsolation?: boolean;
  scrollLock?: boolean;
  onCloseRequest?: () => void;
}

const Modal: React.FunctionComponent<ModalDialogProps> = ({
  background = true,
  children,
  focusLock = true,
  scrollIsolation = true,
  scrollLock = true,
  onCloseRequest = () => {},
}) => {
  const childrenContainer = useRef<HTMLDivElement>(null);

  const closeModal = (event: React.SyntheticEvent) => {
    if (
      !childrenContainer ||
      childrenContainer.current?.contains(event.target as Element)
    ) {
      return;
    }
    const JGCookieConsentBar = document.querySelector(
      '.jg-chrome-cookie-consent',
    );
    if (JGCookieConsentBar?.contains(event.target as Element)) {
      return;
    }

    onCloseRequest();
  };
  useEventListener('mousedown', closeModal);

  const handleKeyPressed = (event: KeyboardEvent) => {
    if (isEscapeKey(event)) {
      onCloseRequest();
    }
  };
  useEventListener('keydown', handleKeyPressed);

  return (
    <RemoveScroll enabled={scrollLock} noIsolation={scrollIsolation}>
      <div
        data-qa="modal-backdrop"
        className={classNames({ [styles.background]: background })}
      >
        <FocusLock
          disabled={!focusLock}
          returnFocus
          persistentFocus
          className={styles.focusLock}
        >
          <div role="dialog" aria-modal="true" ref={childrenContainer}>
            {children}
          </div>
        </FocusLock>
      </div>
    </RemoveScroll>
  );
};

export default Modal;
